@file:Suppress(
    "RETURN_VALUE_NOT_USED",
    "RETURN_VALUE_NOT_USED_COERCION",
)

import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlin.Suppress
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable
import dev.tonholo.s2c.website.components.layouts.PageLayout as _dev_tonholo_s2c_website_components_layouts_PageLayout
import dev.tonholo.s2c.website.pages.HomePage as _dev_tonholo_s2c_website_pages_HomePage
import dev.tonholo.s2c.website.pages.docs.AlternativesPage as _dev_tonholo_s2c_website_pages_docs_AlternativesPage
import dev.tonholo.s2c.website.pages.docs.CliDocsPage as _dev_tonholo_s2c_website_pages_docs_CliDocsPage
import dev.tonholo.s2c.website.pages.docs.DocsPage as _dev_tonholo_s2c_website_pages_docs_DocsPage
import dev.tonholo.s2c.website.pages.docs.FaqPage as _dev_tonholo_s2c_website_pages_docs_FaqPage
import dev.tonholo.s2c.website.pages.docs.GradlePluginDocsPage as _dev_tonholo_s2c_website_pages_docs_GradlePluginDocsPage

public fun main() {
    AppGlobals.initialize(mapOf("title" to "Svg-to-Compose"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.registerLayout(
            "dev.tonholo.s2c.website.components.layouts.PageLayout",
        ) { pageCtx, pageMethod -> 
            _dev_tonholo_s2c_website_components_layouts_PageLayout(pageCtx) {
                pageMethod(pageCtx)
            }
        }
        ctx.router.register(
            "/",
            layoutId = "dev.tonholo.s2c.website.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                dev.tonholo.s2c.website.pages.initHomePage(ctx)
            },
        ) { pageCtx -> 
            _dev_tonholo_s2c_website_pages_HomePage()
        }
        ctx.router.register(
            "/docs/",
            layoutId = "dev.tonholo.s2c.website.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                dev.tonholo.s2c.website.pages.docs.initDocsPage(ctx)
            },
        ) { pageCtx -> 
            _dev_tonholo_s2c_website_pages_docs_DocsPage()
        }
        ctx.router.register(
            "/docs/alternatives",
            layoutId = "dev.tonholo.s2c.website.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                dev.tonholo.s2c.website.pages.docs.initAlternativesPage(ctx)
            },
        ) { pageCtx -> 
            _dev_tonholo_s2c_website_pages_docs_AlternativesPage()
        }
        ctx.router.register(
            "/docs/cli",
            layoutId = "dev.tonholo.s2c.website.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                dev.tonholo.s2c.website.pages.docs.initCliDocsPage(ctx)
            },
        ) { pageCtx -> 
            _dev_tonholo_s2c_website_pages_docs_CliDocsPage()
        }
        ctx.router.register(
            "/docs/faq",
            layoutId = "dev.tonholo.s2c.website.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                dev.tonholo.s2c.website.pages.docs.initFaqPage(ctx)
            },
        ) { pageCtx -> 
            _dev_tonholo_s2c_website_pages_docs_FaqPage()
        }
        ctx.router.register(
            "/docs/gradle-plugin",
            layoutId = "dev.tonholo.s2c.website.components.layouts.PageLayout",
            initRouteMethod = { ctx ->
                dev.tonholo.s2c.website.pages.docs.initGradlePluginDocsPage(ctx)
            },
        ) { pageCtx -> 
            _dev_tonholo_s2c_website_pages_docs_GradlePluginDocsPage()
        }

    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("root", dev.tonholo.s2c.website.components.layouts.RootStyle)
        ctx.theme.registerStyle("docs-layout", dev.tonholo.s2c.website.components.layouts.DocsLayoutStyle)
        ctx.theme.registerStyle("docs-content", dev.tonholo.s2c.website.components.layouts.DocsContentStyle)
        ctx.theme.registerStyle("docs-title", dev.tonholo.s2c.website.components.layouts.DocsTitleStyle)
        ctx.theme.registerStyle("section-container", dev.tonholo.s2c.website.components.layouts.SectionContainerStyle)
        ctx.theme.registerStyle("section-content", dev.tonholo.s2c.website.components.layouts.SectionContentStyle)
        ctx.theme.registerStyle("options-container", dev.tonholo.s2c.website.components.organisms.playground.OptionsContainerStyle)
        ctx.theme.registerStyle("option-input", dev.tonholo.s2c.website.components.organisms.playground.OptionInputStyle)
        ctx.theme.registerStyle("options-input-grid", dev.tonholo.s2c.website.components.organisms.playground.OptionsInputGridStyle)
        ctx.theme.registerStyle("playground-heading-container", dev.tonholo.s2c.website.components.organisms.playground.PlaygroundHeadingContainerStyle)
        ctx.theme.registerStyle("editor-panel", dev.tonholo.s2c.website.components.organisms.playground.EditorPanelStyle)
        ctx.theme.registerStyle("desktop-panels", dev.tonholo.s2c.website.components.organisms.playground.DesktopPanelsStyle)
        ctx.theme.registerStyle("mobile-panel-content", dev.tonholo.s2c.website.components.organisms.playground.MobilePanelContentStyle)
        ctx.theme.registerStyle("input-panel", dev.tonholo.s2c.website.components.organisms.playground.InputPanelStyle)
        ctx.theme.registerStyle("editor-container", dev.tonholo.s2c.website.components.organisms.playground.EditorContainerStyle)
        ctx.theme.registerStyle("editor-backdrop", dev.tonholo.s2c.website.components.organisms.playground.EditorBackdropStyle)
        ctx.theme.registerStyle("editor-textarea", dev.tonholo.s2c.website.components.organisms.playground.EditorTextareaStyle)
        ctx.theme.registerStyle("upload-panel", dev.tonholo.s2c.website.components.organisms.playground.UploadPanelStyle)
        ctx.theme.registerStyle("upload-drop-zone", dev.tonholo.s2c.website.components.organisms.playground.UploadDropZoneStyle)
        ctx.theme.registerStyle("upload-button", dev.tonholo.s2c.website.components.organisms.playground.UploadButtonStyle)
        ctx.theme.registerStyle("comparison-strip", dev.tonholo.s2c.website.components.organisms.playground.ComparisonStripStyle)
        ctx.theme.registerStyle("comparison-row", dev.tonholo.s2c.website.components.organisms.playground.ComparisonRowStyle)
        ctx.theme.registerStyle("preview-column", dev.tonholo.s2c.website.components.organisms.playground.PreviewColumnStyle)
        ctx.theme.registerStyle("batch-panel", dev.tonholo.s2c.website.components.organisms.playground.BatchPanelStyle)
        ctx.theme.registerStyle("batch-panel-file-list", dev.tonholo.s2c.website.components.organisms.playground.BatchPanelFileListStyle)
        ctx.theme.registerStyle("batch-phase-header", dev.tonholo.s2c.website.components.organisms.playground.BatchPhaseHeaderStyle)
        ctx.theme.registerStyle("batch-phase-progress-bar-container", dev.tonholo.s2c.website.components.organisms.playground.BatchPhaseProgressBarContainerStyle)
        ctx.theme.registerStyle("batch-phase-progress-bar-fill", dev.tonholo.s2c.website.components.organisms.playground.BatchPhaseProgressBarFillStyle)
        ctx.theme.registerStyle("batch-phase-primary-button", dev.tonholo.s2c.website.components.organisms.playground.BatchPhasePrimaryButtonStyle)
        ctx.theme.registerStyle("batch-phase-secondary-button", dev.tonholo.s2c.website.components.organisms.playground.BatchPhaseSecondaryButtonStyle)
        ctx.theme.registerStyle("output-panel", dev.tonholo.s2c.website.components.organisms.playground.OutputPanelStyle)
        ctx.theme.registerStyle("output-code", dev.tonholo.s2c.website.components.organisms.playground.OutputCodeStyle)
        ctx.theme.registerStyle("toolbar", dev.tonholo.s2c.website.components.organisms.playground.ToolbarStyle)
        ctx.theme.registerStyle("toolbar-button-row", dev.tonholo.s2c.website.components.organisms.playground.ToolbarButtonRowStyle)
        ctx.theme.registerStyle("sample-button", dev.tonholo.s2c.website.components.organisms.playground.SampleButtonStyle)
        ctx.theme.registerStyle("toolbar-button", dev.tonholo.s2c.website.components.organisms.playground.ToolbarButtonStyle)
        ctx.theme.registerStyle("install-content", dev.tonholo.s2c.website.components.organisms.InstallContentStyle)
        ctx.theme.registerStyle("docs-body-text", dev.tonholo.s2c.website.components.organisms.docs.DocsBodyTextStyle)
        ctx.theme.registerStyle("docs-bullet-list", dev.tonholo.s2c.website.components.organisms.docs.DocsBulletListStyle)
        ctx.theme.registerStyle("docs-table", dev.tonholo.s2c.website.components.organisms.docs.DocsTableStyle)
        ctx.theme.registerStyle("docs-table-header", dev.tonholo.s2c.website.components.organisms.docs.DocsTableHeaderStyle)
        ctx.theme.registerStyle("docs-table-cell", dev.tonholo.s2c.website.components.organisms.docs.DocsTableCellStyle)
        ctx.theme.registerStyle("cli-docs-options-table", dev.tonholo.s2c.website.components.organisms.docs.CliDocsOptionsTableStyle)
        ctx.theme.registerStyle("compact-intro", dev.tonholo.s2c.website.components.organisms.CompactIntroStyle)
        ctx.theme.registerStyle("intro-content", dev.tonholo.s2c.website.components.organisms.IntroContentStyle)
        ctx.theme.registerStyle("nav-header", dev.tonholo.s2c.website.components.organisms.NavHeaderStyle)
        ctx.theme.registerStyle("nav-container", dev.tonholo.s2c.website.components.organisms.NavContainerStyle)
        ctx.theme.registerStyle("compact-logo", dev.tonholo.s2c.website.components.organisms.CompactLogoStyle)
        ctx.theme.registerStyle("full-logo", dev.tonholo.s2c.website.components.organisms.FullLogoStyle)
        ctx.theme.registerStyle("git-hub-button", dev.tonholo.s2c.website.components.organisms.GitHubButtonStyle)
        ctx.theme.registerStyle("links-and-attribution", dev.tonholo.s2c.website.components.organisms.footer.LinksAndAttributionStyle)
        ctx.theme.registerStyle("footer", dev.tonholo.s2c.website.components.organisms.footer.FooterStyle)
        ctx.theme.registerStyle("footer-content", dev.tonholo.s2c.website.components.organisms.footer.FooterContentStyle)
        ctx.theme.registerStyle("footer-inner-content", dev.tonholo.s2c.website.components.organisms.footer.FooterInnerContentStyle)
        ctx.theme.registerStyle("capabilities-grid", dev.tonholo.s2c.website.components.organisms.CapabilitiesGridStyle)
        ctx.theme.registerStyle("usage-tab-content", dev.tonholo.s2c.website.components.organisms.UsageTabContentStyle)
        ctx.theme.registerStyle("gradle-usage-card-grid", dev.tonholo.s2c.website.components.organisms.howtouse.GradleUsageCardGridStyle)
        ctx.theme.registerStyle("cli-usage-card-grid", dev.tonholo.s2c.website.components.organisms.howtouse.CliUsageCardGridStyle)
        ctx.theme.registerStyle("options-table", dev.tonholo.s2c.website.components.organisms.howtouse.OptionsTableStyle)
        ctx.theme.registerStyle("doc-section", dev.tonholo.s2c.website.components.atoms.DocSectionStyle)
        ctx.theme.registerStyle("doc-section-level3-heading", dev.tonholo.s2c.website.components.atoms.DocSectionLevel3HeadingStyle)
        ctx.theme.registerStyle("inline-code", dev.tonholo.s2c.website.components.atoms.InlineCodeStyle)
        ctx.theme.registerStyle("banner", dev.tonholo.s2c.website.components.atoms.BannerStyle)
        ctx.theme.registerStyle("nav-link", dev.tonholo.s2c.website.components.atoms.NavLinkStyle)
        ctx.theme.registerStyle("badge", dev.tonholo.s2c.website.components.atoms.BadgeStyle)
        ctx.theme.registerStyle("checkerboard-preview", dev.tonholo.s2c.website.components.atoms.CheckerboardPreviewStyle)
        ctx.theme.registerStyle("tab-bar", dev.tonholo.s2c.website.components.molecules.TabBarStyle)
        ctx.theme.registerStyle("active-tab", dev.tonholo.s2c.website.components.molecules.ActiveTabStyle)
        ctx.theme.registerStyle("inactive-tab", dev.tonholo.s2c.website.components.molecules.InactiveTabStyle)
        ctx.theme.registerStyle("code-block-container", dev.tonholo.s2c.website.components.molecules.CodeBlockContainerStyle)
        ctx.theme.registerStyle("code-block-header", dev.tonholo.s2c.website.components.molecules.CodeBlockHeaderStyle)
        ctx.theme.registerStyle("copy-button", dev.tonholo.s2c.website.components.molecules.CopyButtonStyle)
        ctx.theme.registerStyle("line-number", dev.tonholo.s2c.website.components.molecules.LineNumberStyle)
        ctx.theme.registerStyle("chip-container", dev.tonholo.s2c.website.components.molecules.ChipContainerStyle)
        ctx.theme.registerStyle("active-chip", dev.tonholo.s2c.website.components.molecules.ActiveChipStyle)
        ctx.theme.registerStyle("inactive-chip", dev.tonholo.s2c.website.components.molecules.InactiveChipStyle)
        ctx.theme.registerStyle("feedback-button-row", dev.tonholo.s2c.website.components.molecules.playground.FeedbackButtonRowStyle)
        ctx.theme.registerStyle("mobile-tab-bar", dev.tonholo.s2c.website.components.molecules.playground.MobileTabBarStyle)
        ctx.theme.registerStyle("mobile-tab", dev.tonholo.s2c.website.components.molecules.playground.MobileTabStyle)
        ctx.theme.registerStyle("zoom-button", dev.tonholo.s2c.website.components.molecules.playground.ZoomButtonStyle)
        ctx.theme.registerStyle("file-drop-overlay", dev.tonholo.s2c.website.components.molecules.playground.FileDropOverlayStyle)
        ctx.theme.registerStyle("file-drop-overlay-inner", dev.tonholo.s2c.website.components.molecules.playground.FileDropOverlayInnerStyle)
        ctx.theme.registerStyle("convert-button", dev.tonholo.s2c.website.components.molecules.playground.ConvertButtonStyle)
        ctx.theme.registerStyle("spinner-icon", dev.tonholo.s2c.website.components.molecules.playground.SpinnerIconStyle)
        ctx.theme.registerStyle("file-row", dev.tonholo.s2c.website.components.molecules.playground.FileRowStyle)
        ctx.theme.registerStyle("file-row-clickable", dev.tonholo.s2c.website.components.molecules.playground.FileRowClickableStyle)
        ctx.theme.registerStyle("file-extension-badge", dev.tonholo.s2c.website.components.molecules.playground.FileExtensionBadgeStyle)
        ctx.theme.registerStyle("file-row-error-text", dev.tonholo.s2c.website.components.molecules.playground.FileRowErrorTextStyle)
        ctx.theme.registerStyle("file-row-checkbox", dev.tonholo.s2c.website.components.molecules.playground.FileRowCheckboxStyle)
        ctx.theme.registerStyle("file-row-unchecked", dev.tonholo.s2c.website.components.molecules.playground.FileRowUncheckedStyle)
        ctx.theme.registerStyle("file-row-name", dev.tonholo.s2c.website.components.molecules.playground.FileRowNameStyle)
        ctx.theme.registerStyle("file-group-header", dev.tonholo.s2c.website.components.molecules.playground.FileGroupHeaderStyle)
        ctx.theme.registerStyle("file-group-progress-bar-track", dev.tonholo.s2c.website.components.molecules.playground.FileGroupProgressBarTrackStyle)
        ctx.theme.registerStyle("file-group-progress-bar-fill", dev.tonholo.s2c.website.components.molecules.playground.FileGroupProgressBarFillStyle)
        ctx.theme.registerStyle("collapsible-container", dev.tonholo.s2c.website.components.molecules.CollapsibleContainerStyle)
        ctx.theme.registerStyle("collapsible-header", dev.tonholo.s2c.website.components.molecules.CollapsibleHeaderStyle)
        ctx.theme.registerStyle("doc-nav-dropdown-trigger", dev.tonholo.s2c.website.components.molecules.DocNavDropdownTriggerStyle)
        ctx.theme.registerStyle("doc-nav-dropdown-panel", dev.tonholo.s2c.website.components.molecules.DocNavDropdownPanelStyle)
        ctx.theme.registerStyle("doc-nav-dropdown-link", dev.tonholo.s2c.website.components.molecules.DocNavDropdownLinkStyle)
        ctx.theme.registerStyle("toc-container", dev.tonholo.s2c.website.components.molecules.TocContainerStyle)
        ctx.theme.registerStyle("toc-link", dev.tonholo.s2c.website.components.molecules.TocLinkStyle)
        ctx.theme.registerStyle("toc-active-link", dev.tonholo.s2c.website.components.molecules.TocActiveLinkStyle)
        ctx.theme.registerStyle("doc-callout", dev.tonholo.s2c.website.components.molecules.DocCalloutStyle)
        ctx.theme.registerStyle("attribution", dev.tonholo.s2c.website.components.molecules.footer.AttributionStyle)
        ctx.theme.registerStyle("usage-card", dev.tonholo.s2c.website.components.molecules.UsageCardStyle)
        ctx.theme.registerStyle("cta-row", dev.tonholo.s2c.website.components.molecules.CtaRowStyle)
        ctx.theme.registerStyle("primary-cta", dev.tonholo.s2c.website.components.molecules.PrimaryCtaStyle)
        ctx.theme.registerStyle("secondary-cta", dev.tonholo.s2c.website.components.molecules.SecondaryCtaStyle)
        ctx.theme.registerStyle("options-header-row", dev.tonholo.s2c.website.components.molecules.OptionsHeaderRowStyle)
        ctx.theme.registerStyle("options-row", dev.tonholo.s2c.website.components.molecules.OptionsRowStyle)
        ctx.theme.registerStyle("panel-header", dev.tonholo.s2c.website.components.molecules.PanelHeaderStyle)
        ctx.theme.registerStyle("docs-container", dev.tonholo.s2c.website.pages.docs.DocsContainerStyle)
        ctx.theme.registerStyle("docs-header", dev.tonholo.s2c.website.pages.docs.DocsHeaderStyle)
        ctx.theme.registerStyle("docs-grid", dev.tonholo.s2c.website.pages.docs.DocsGridStyle)
        ctx.theme.registerStyle("docs-card", dev.tonholo.s2c.website.pages.docs.DocsCardStyle)
        ctx.theme.registerStyle("shiki-code-block", dev.tonholo.s2c.website.shiki.ShikiCodeBlockStyle)
        ctx.theme.registerStyle("display-text", dev.tonholo.s2c.website.theme.DisplayTextStyle)
        ctx.theme.registerStyle("headline-text", dev.tonholo.s2c.website.theme.HeadlineTextStyle)
        ctx.theme.registerStyle("subheadline-text", dev.tonholo.s2c.website.theme.SubheadlineTextStyle)
        ctx.theme.registerStyle("monospace-text", dev.tonholo.s2c.website.theme.MonospaceTextStyle)
        ctx.theme.registerStyle("label-text", dev.tonholo.s2c.website.theme.LabelTextStyle)
        ctx.theme.registerVariant("-version", dev.tonholo.s2c.website.components.organisms.VersionBadgeVariant
        )
        ctx.theme.registerVariant("-see-full-documentation-link-button", dev.tonholo.s2c.website.components.organisms.howtouse.SeeFullDocumentationLinkButton
        )
        ctx.theme.registerVariant("-squared", dev.tonholo.s2c.website.components.atoms.SquaredBadge
        )
        ctx.theme.registerVariant("-feedback", dev.tonholo.s2c.website.components.molecules.playground.FeedbackLinkVariant
        )
        ctx.theme.registerVariant("-footer-links", dev.tonholo.s2c.website.components.molecules.footer.FooterLinksVariant
        )
        ctx.theme.registerVariant("-docs", dev.tonholo.s2c.website.components.molecules.footer.DocsLinkVariant
        )
        ctx.theme.registerVariant("-footer-link", dev.tonholo.s2c.website.components.molecules.footer.FooterLinkBadgeVariant
        )
        ctx.theme.registerVariant("-attribution", dev.tonholo.s2c.website.components.molecules.footer.AttributionLinkVariant
        )
        ctx.theme.registerVariant("-odd-row", dev.tonholo.s2c.website.components.molecules.OddRowVariant
        )
        ctx.theme.registerVariant("-docs-card", dev.tonholo.s2c.website.pages.docs.DocsCardLinkVariant
        )
        ctx.theme.registerVariant("-circle", dev.tonholo.s2c.website.theme.CircleButtonVariant
        )
        ctx.theme.registerVariant("-uncolored", dev.tonholo.s2c.website.theme.UncoloredButtonVariant
        )
        ctx.theme.registerVariant("-site-link-style", dev.tonholo.s2c.website.theme.common.SiteLinkStyleVariant
        )
        ctx.theme.registerKeyframes("side-menu-slide-in", dev.tonholo.s2c.website.components.organisms.SideMenuSlideInAnim)
        ctx.theme.registerKeyframes("spin", dev.tonholo.s2c.website.theme.SpinKeyframes)
        dev.tonholo.s2c.website.theme.initTheme(ctx)
        dev.tonholo.s2c.website.theme.initSiteStyles(ctx)
        dev.tonholo.s2c.website.initSilk(ctx)
    }

    // Dedup any leading slashes after removing the origin, just in case someone typed
    // something like `https://site.com//about` by accident. If we pass `//about` into
    // `tryRoutingTo`, Kobweb will reject it as a protocol-relative URL; instead, we
    // want it to navigate to `/about`
    router.tryRoutingTo(BasePath.remove("/" + window.location.href.removePrefix(window.origin).trimStart('/')), UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        dev.tonholo.s2c.website.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
